import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BadgeListItem from './BadgeListItem';
import ClientProvider from './client';
export default createDemo(import.meta.url, BadgeListItem, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/badges/demos/list-item/BadgeListItem.tsx",
    "fileName": "BadgeListItem.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Badge from '@mui/material/Badge';\nimport List from '@mui/material/List';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Paper from '@mui/material/Paper';\nimport DraftsIcon from '@mui/icons-material/Drafts';\nimport InboxIcon from '@mui/icons-material/Inbox';\nimport SendIcon from '@mui/icons-material/Send';\n\nconst unreadMessagesCount = 4;\n\nexport default function BadgeListItem() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Paper variant=\"outlined\" sx={{ width: 320, maxWidth: '100%' }}>\n      <List component=\"nav\" aria-label=\"mail folders\" sx={{ py: 0 }}>\n        <ListItemButton\n          selected\n          aria-current=\"page\"\n          aria-label={`Inbox, ${unreadMessagesCount} unread messages`}\n        >\n          <ListItemIcon>\n            <Badge badgeContent={unreadMessagesCount} color=\"primary\">\n              <InboxIcon />\n            </Badge>\n          </ListItemIcon>\n          <ListItemText primary=\"Inbox\" />\n        </ListItemButton>\n        <ListItemButton>\n          <ListItemIcon>\n            <SendIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Sent\" />\n        </ListItemButton>\n        <ListItemButton>\n          <ListItemIcon>\n            <DraftsIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Drafts\" />\n        </ListItemButton>\n      </List>\n    </Paper>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 44,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Badge from '@mui/material/Badge';\nimport List from '@mui/material/List';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport Paper from '@mui/material/Paper';\nimport DraftsIcon from '@mui/icons-material/Drafts';\nimport InboxIcon from '@mui/icons-material/Inbox';\nimport SendIcon from '@mui/icons-material/Send';\n\nconst unreadMessagesCount = 4;\n\nexport default function BadgeListItem() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Paper variant=\"outlined\" sx={{ width: 320, maxWidth: '100%' }}>\n      <List component=\"nav\" aria-label=\"mail folders\" sx={{ py: 0 }}>\n        <ListItemButton\n          selected\n          aria-current=\"page\"\n          aria-label={`Inbox, ${unreadMessagesCount} unread messages`}\n        >\n          <ListItemIcon>\n            <Badge badgeContent={unreadMessagesCount} color=\"primary\">\n              <InboxIcon />\n            </Badge>\n          </ListItemIcon>\n          <ListItemText primary=\"Inbox\" />\n        </ListItemButton>\n        <ListItemButton>\n          <ListItemIcon>\n            <SendIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Sent\" />\n        </ListItemButton>\n        <ListItemButton>\n          <ListItemIcon>\n            <DraftsIcon />\n          </ListItemIcon>\n          <ListItemText primary=\"Drafts\" />\n        </ListItemButton>\n      </List>\n    </Paper>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 44,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Badge",
      "@mui/material/List",
      "@mui/material/ListItemButton",
      "@mui/material/ListItemIcon",
      "@mui/material/ListItemText",
      "@mui/material/Paper",
      "@mui/icons-material/Drafts",
      "@mui/icons-material/Inbox",
      "@mui/icons-material/Send"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
